import {BasicPage} from "../basic/BasicPage";
import sponsorList from './sponsors.json';
import {useTranslation} from "react-i18next";

export const SponsorsPage = ({content})=>{
    const { t } = useTranslation();
    return <>
    <div className="sponsors">
        <h1 className="text-center mb-4">{t("sponsors.thanksSponsors")}</h1>
        <div className="container">
            <div className="row justify-content-center">
                <div className="col-md-10 col-lg-8"><hr /></div>
            </div>
        </div>
        <SponsorsView />
        <div className="container">
            <div className="row justify-content-center">
                <div className="col-md-10 col-lg-8"><hr /></div>
            </div>
        </div>
    </div>
        <BasicPage content={content}/>
    </>
}

const groupByTier = (sponsors) => {
    return sponsors.reduce((acc, sponsor) => {
        if (!acc[sponsor.tier]) {
            acc[sponsor.tier] = [];
        }
        acc[sponsor.tier].push(sponsor);
        return acc;
    }, {});
};

export const SponsorsView = ({ filterFn }) => {
    const { t } = useTranslation();
    let sponsors = sponsorList.sponsors;

    if (typeof filterFn === "function") {
        sponsors = sponsors.filter(filterFn);
    }

    const sponsorsByTier = groupByTier(sponsors);

    return (
            <div className="container pt-4">
                {Object.entries(sponsorsByTier).map(([tier, sponsors]) => (
                    <div key={tier} className="sponsor-tier">
                        <h2 className="text-center mb-0">{tier}</h2>
                        <div className="sponsors__content row justify-content-center">
                            {sponsors.map((sponsor) => (
                                <div className="col-md-6 col-lg-4 sponsor" key={sponsor.name}>
                                    <a href={sponsor.link} target="_blank" rel="noopener">
                                        <img src={sponsor.image} alt={sponsor.name} />
                                    </a>
                                </div>
                            ))}
                        </div>
                    </div>
                ))}
            </div>
    );
};